import cn from 'classnames';
import styles from './Dropdown.module.scss';

export const getClassNames = (className?: string) => {
  return cn(styles.dropdown, className);
};
